import { differenceInDays, format, isToday, isYesterday } from "date-fns";
import es from "date-fns/locale/es";
import en from "date-fns/locale/en";
import pt from "date-fns/locale/pt";
import capitalize from "lodash/capitalize";

import { get as getText, getLang } from "util/i18n";
import { get as getConfig } from "util/config";

const locale = { es, en, pt };

export const date = (dateToFormat, formatDate = null, lang = null) => {
    const currentLang = getLang();

    const shortDateFormat = getConfig("frontend.shortDateFormat").toUpperCase();
    return format(dateToFormat, formatDate || shortDateFormat, { locale: locale[lang || currentLang] });
};

export const naturalDate = (dateToFormat) => {
    const wordBeforeTime = getText("settings.lastLogin.beforeTime");

    if (isToday(dateToFormat)) {
        const wordToday = getText("scheduler.executionToday");

        return capitalize(`${wordToday} ${wordBeforeTime} ${date(dateToFormat, "HH:mm")}`);
    }
    if (isYesterday(dateToFormat)) {
        const wordYesterday = getText("scheduler.executionYesterday");

        return capitalize(`${wordYesterday} ${wordBeforeTime} ${date(dateToFormat, "HH:mm")}`);
    }
    if (differenceInDays(new Date(), dateToFormat) < 7) {
        return capitalize(date(dateToFormat, `dddd [${wordBeforeTime}] HH:mm`));
    }

    return capitalize(date(dateToFormat, getText("datepicker.format")));
};

export const formatNum = (x, fixedDecimals = 0) => {
    const num = typeof x === "string" && x.includes(",") ? Number(x.replace(",", ".")) : Number(x);

    // Se comenta por el bug ARBIBIMPLE-
    // const million = 1000000;
    // if (num >= million) return Math.trunc(num / million) + getText("formattedAmount.millionAbbreviature")

    let numWith2DecimalsMax;
    if (fixedDecimals) {
        numWith2DecimalsMax = (Math.floor(num * 100) / 100).toFixed(fixedDecimals);
    } else if (num - Math.trunc(num) < 0.01) {
        numWith2DecimalsMax = Math.trunc(num);
    } else if (num - Math.trunc(num * 10) / 10 < 0.1) {
        numWith2DecimalsMax = (Math.floor(num * 100) / 100).toFixed(1);
    } else {
        numWith2DecimalsMax = (Math.floor(num * 100) / 100).toFixed(2);
    }
    return numWith2DecimalsMax
        .toString()
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    // Format: 10.456.123,45  10M
};

export const documentTypeFormats = (documentType, document) => {
    const isnum = /^\d+$/.test(document);
    if (documentType === "DNI") {
        if (document.length < 6 || document.length > 8 || !isnum) {
            return false;
        }
    }

    if (documentType === "CUIT" || documentType === "CUIL" || documentType === "CDI") {
        if (document.length !== 11 || !isnum) {
            return false;
        }
    }
    if (documentType === "CBU" || documentType === "CVU") {
        if (document.length !== 22 || !isnum) {
            return false;
        }
    }
    if (documentType === "ALIAS") {
        if (document.length > 20) {
            return false;
        }
    }
    return true;
};

export const shortFormatAccountLabel = (account = {}) =>
    `····${account.accountNumber?.slice(-4)} ${account.accountType} ${account.currency}`;

export default {};
